// Mock fallback — ใช้เฉพาะตอนโหลดข้อมูลจริงจาก API ไม่ได้
// shape ตรงกับ output ของ adaptExecutiveSummary.js

export const YEAR_OPTIONS = [2026, 2025, 2024, 2023];

export const INBOUND_SUMMARY = {
  title: "Inbound Summary",
  keyLabel: "Company",
  warehouses: ["GZ", "YW"],
  periods: [
    {
      key: "today",
      label: "Today Total",
      total: "120,080.23 CBM",
      rows: [
        { key: "CA", name: "CA", sea: { GZ: "3,125.12", YW: "2,820.44" }, land: { GZ: "1,503.41", YW: "1,303.55" } },
        { key: "BB", name: "BB", sea: { GZ: "2,345.23", YW: "2,040.55" }, land: { GZ: "1,745.65", YW: "1,140.66" } },
        { key: "KK", name: "KK", sea: { GZ: "2,025.34", YW: "1,758.56" }, land: { GZ: "1,505.34", YW: "1,194.23" } },
        { key: "BOR", name: "BOR", sea: { GZ: "2,005.56", YW: "808.09" }, land: { GZ: "4,125.62", YW: "878.77" } },
        { key: "MP", name: "MP", sea: { GZ: "1,805.67", YW: "706.12" }, land: { GZ: "905.33", YW: "612.45" } },
      ],
    },
    {
      key: "month",
      label: "Month Total",
      total: "350,450.13 CBM",
      rows: [
        { key: "CA", name: "CA", sea: { GZ: "9,210.40", YW: "8,150.22" }, land: { GZ: "4,420.11", YW: "3,880.33" } },
        { key: "BB", name: "BB", sea: { GZ: "7,140.55", YW: "6,050.18" }, land: { GZ: "5,120.70", YW: "3,360.90" } },
        { key: "KK", name: "KK", sea: { GZ: "6,330.20", YW: "5,210.44" }, land: { GZ: "4,510.34", YW: "3,560.12" } },
        { key: "BOR", name: "BOR", sea: { GZ: "5,880.10", YW: "2,420.33" }, land: { GZ: "9,120.55", YW: "2,640.70" } },
        { key: "MP", name: "MP", sea: { GZ: "5,330.66", YW: "2,110.20" }, land: { GZ: "2,720.40", YW: "1,840.10" } },
      ],
    },
    {
      key: "year",
      label: "Year 2026 Total",
      total: "1,950,420.83 CBM",
      rows: [
        { key: "CA", name: "CA", sea: { GZ: "48,220.50", YW: "42,150.30" }, land: { GZ: "23,420.10", YW: "20,880.40" } },
        { key: "BB", name: "BB", sea: { GZ: "37,140.20", YW: "31,050.60" }, land: { GZ: "27,120.80", YW: "17,360.50" } },
        { key: "KK", name: "KK", sea: { GZ: "33,330.40", YW: "27,210.10" }, land: { GZ: "24,510.70", YW: "18,560.20" } },
        { key: "BOR", name: "BOR", sea: { GZ: "30,880.60", YW: "12,420.90" }, land: { GZ: "48,120.30", YW: "13,640.10" } },
        { key: "MP", name: "MP", sea: { GZ: "28,330.10", YW: "11,110.50" }, land: { GZ: "14,720.60", YW: "9,840.70" } },
      ],
    },
  ],
};

export const PACKAGE_TYPE_SUMMARY = {
  title: "Package Type Summary",
  keyLabel: "Type",
  warehouses: ["GZ", "YW"],
  periods: [
    {
      key: "today",
      label: "Today Total",
      total: "120,080.23 CBM",
      rows: [
        { key: "A", name: "A", sea: { GZ: "3,210.10", YW: "2,150.20" }, land: { GZ: "1,450.30", YW: "1,290.40" } },
        { key: "B", name: "B", sea: { GZ: "2,840.15", YW: "1,560.25" }, land: { GZ: "1,380.35", YW: "1,240.45" } },
        { key: "C", name: "C", sea: { GZ: "3,610.20", YW: "2,890.30" }, land: { GZ: "1,510.40", YW: "1,360.50" } },
        { key: "D", name: "D", sea: { GZ: "1,670.25", YW: "1,430.35" }, land: { GZ: "1,290.45", YW: "1,180.55" } },
        { key: "E", name: "E", sea: { GZ: "2,930.30", YW: "1,620.40" }, land: { GZ: "1,400.50", YW: "1,270.60" } },
      ],
    },
    {
      key: "month",
      label: "Month Total",
      total: "350,450.13 CBM",
      rows: [
        { key: "A", name: "A", sea: { GZ: "9,210.30", YW: "6,150.40" }, land: { GZ: "4,150.20", YW: "3,690.10" } },
        { key: "B", name: "B", sea: { GZ: "8,140.25", YW: "4,560.35" }, land: { GZ: "3,980.15", YW: "3,540.45" } },
        { key: "C", name: "C", sea: { GZ: "10,610.40", YW: "8,290.30" }, land: { GZ: "4,510.20", YW: "3,960.50" } },
        { key: "D", name: "D", sea: { GZ: "4,670.35", YW: "4,130.25" }, land: { GZ: "3,290.45", YW: "3,180.55" } },
        { key: "E", name: "E", sea: { GZ: "8,330.30", YW: "4,920.40" }, land: { GZ: "4,100.50", YW: "3,470.60" } },
      ],
    },
    {
      key: "year",
      label: "Year 2026 Total",
      total: "1,950,420.83 CBM",
      rows: [
        { key: "A", name: "A", sea: { GZ: "48,210.30", YW: "32,150.40" }, land: { GZ: "21,150.20", YW: "18,690.10" } },
        { key: "B", name: "B", sea: { GZ: "41,140.25", YW: "24,560.35" }, land: { GZ: "20,980.15", YW: "18,540.45" } },
        { key: "C", name: "C", sea: { GZ: "52,610.40", YW: "42,290.30" }, land: { GZ: "23,510.20", YW: "19,960.50" } },
        { key: "D", name: "D", sea: { GZ: "24,670.35", YW: "21,130.25" }, land: { GZ: "16,290.45", YW: "15,180.55" } },
        { key: "E", name: "E", sea: { GZ: "43,330.30", YW: "25,920.40" }, land: { GZ: "21,100.50", YW: "17,470.60" } },
      ],
    },
  ],
};

export const KPI_CARDS = [
  { key: "revenue", title: "Revenue", value: "฿ 21,008,750", trend: "+17.5%", trendLabel: "vs Last Month", positive: true, icon: "revenue" },
  { key: "shipments", title: "Total Shipments", value: "2,068,750.00 CBM", trend: "+17.5%", trendLabel: "vs Last Month", positive: true, icon: "shipments" },
  { key: "delivered", title: "Delivered Packages", value: "1,084,375.00 CBM", trend: "+15.2%", trendLabel: "vs Last Month", positive: true, icon: "delivered" },
  { key: "destination", title: "Destination Transport", value: "984,375.00 CBM", trend: "+8.2%", trendLabel: "vs Last Month", positive: true, icon: "destination" },
];

export const OUTSTANDING_BALANCE = {
  total: "฿ 29,023,760",
  byCompany: "฿ 20,012,483",
  byCustomer: "฿ 9,011,277",
  byCustomerByCompany: [
    { code: "BKK", amount: "฿ 70" },
    { code: "ST", amount: "฿ 20" },
    { code: "UDN", amount: "฿ 10" },
  ],
};

export const FREIGHT_METRICS = {
  sea: {
    title: "SEA Freight",
    baht: "9,018,750",
    cbm: "10,894.00",
    kg: "250,345.00",
    trend: "+17.5%",
    regions: [
      { key: "GZ", region: "GZ", baht: "4,210,500", cbm: "4,200.00", kg: "105,200.00" },
      { key: "YW", region: "YW", baht: "3,180,400", cbm: "3,800.00", kg: "95,100.00" },
    ],
  },
  land: {
    title: "LAND Transport",
    baht: "10,008,750",
    cbm: "10,894.00",
    kg: "250,456.00",
    trend: "+17.5%",
    regions: [
      { key: "GZ", region: "GZ", baht: "3,510,300", cbm: "3,500.00", kg: "90,150.00" },
      { key: "YW", region: "YW", baht: "4,180,250", cbm: "4,100.00", kg: "100,200.00" },
    ],
  },
};

export const SHIPMENT_STATUS = [
  { label: "Origin Warehouse", count: "168,750.00 CBM", pct: 15, color: "#f59e0b" },
  { label: "Going Transit", count: "1,768,750.00 CBM", pct: 62, color: "#2563eb" },
  { label: "Delayed", count: "8,750.00 CBM", pct: 12, color: "#ef4444" },
  { label: "Destination Warehouse", count: "68,750.00 CBM", pct: 21, color: "#22c55e" },
];

export const SHIPMENT_TOTAL = 1250;

export const SHIPMENT_TREND = {
  months: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL"],
  series: [
    // Colors here are for reference only — ChartsSection overrides with TREND_PALETTE by index
    { year: 2023, color: "#16a34a", values: [420, 480, 510, 470, 530, 560, 540] },
    { year: 2024, color: "#eab308", values: [500, 470, 560, 600, 580, 640, 690] },
    { year: 2025, color: "#dc2626", values: [580, 640, 610, 700, 760, 720, 800] },
  ],
};

export const COMPANY_TOP_8 = [
  { rank: 1, code: "CA", volume: "1,768,750" },
  { rank: 2, code: "BB", volume: "1,608,750" },
  { rank: 3, code: "KK", volume: "894,750" },
  { rank: 4, code: "BOR", volume: "800,750" },
  { rank: 5, code: "AM", volume: "559,070" },
  { rank: 6, code: "MP", volume: "459,089" },
  { rank: 7, code: "AOR", volume: "339,045" },
  { rank: 8, code: "CC", volume: "210,330" },
];
